(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("sbWrapperIntegrations", [], factory);
	else if(typeof exports === 'object')
		exports["sbWrapperIntegrations"] = factory();
	else
		root["sbWrapperIntegrations"] = factory();
})(window, function() {
return 